<div class="modal-header">
  <h5 class="text-center cut"
      [translate]="'profile.cakeCalendars.createModal.header'">
    NAME YOUR CALENDAR
    <i class="icon-close" (click)="modal.dismiss()"></i>
  </h5>
</div>

<div class="modal-body">
  <span [translate]="'profile.cakeCalendars.createModal.example'">
    Eksempelvis «bursdager», «fadderbarn» eller «avdeling Oslo»
  </span>

  <div class="mt-3">
    <label class="fw-bold font-xl"
           [translate]="'profile.cakeCalendars.createModal.name'">
      Calendar name
    </label>

    <input type="text"
           class="form-control"
           [autofocus]="true"
           [maxlength]="'64'"
           [placeholder]="'profile.cakeCalendars.createModal.namePlaceholder' | translate"
           [(ngModel)]="group.title">
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-pink"
          (click)="modal.close(group)">
    <span *ngIf="!group?.id"
          [translate]="'profile.cakeCalendars.createModal.create'">
      Create calendar
    </span>

    <span *ngIf="group?.id"
          [translate]="'profile.cakeCalendars.createModal.update'">
      Update calendar
    </span>
  </button>
</div>
